// Safely access a deeply nested object property with default return value
// See also nested_property

import NestedProperty from './nested_property'

export default (defaultVal, path, obj) => NestedProperty(path, obj) || defaultVal
